export * from './Label';
//# sourceMappingURL=index.js.map